export const SITE_ORIGIN = "https://localrankingcoach.com";
export const SITE_LEADS_EMAIL = "service@localrankingcoach.com";

/** Legacy slug → canonical `-seo` slug for dedicated industry landing pages */
export const CANONICAL_INDUSTRY_SLUGS: Record<string, string> = {
  healthcare: "healthcare-seo",
  legal: "legal-seo",
  "real-estate": "real-estate-seo",
  restaurants: "restaurants-seo",
  "home-services": "home-services-seo",
  automotive: "automotive-seo",
  hvac: "hvac-seo",
  roofing: "roofing-seo",
  electricians: "electricians-seo",
  "general-contractors": "general-contractors-seo",
  plumbing: "plumbing-seo",
};

/** 301 redirects for legacy `/industries/{slug}` URLs without `-seo` suffix */
export const LEGACY_INDUSTRY_REDIRECTS: Record<string, string> = Object.fromEntries(
  Object.entries(CANONICAL_INDUSTRY_SLUGS).map(([base, canonical]) => [
    `/industries/${base}`,
    `/industries/${canonical}`,
  ])
);

export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';
